export default __webpack_public_path__ + "static/media/Subjugator Axe.bb21663e.jpg";